import ReactGA from "react-ga4"

let initialized = false
let debugForced = false
const DEBUG_STORAGE_KEY = "ga_debug"

function isBrowser() {
  return typeof window !== "undefined"
}

function debugLog(action: string, payload: Record<string, unknown>) {
  if (!isAnalyticsDebugEnabled()) {
    return
  }

  // Keep debug output grouped and searchable in devtools.
  console.info("[analytics]", action, payload)
}

export function isAnalyticsDebugEnabled() {
  if (!isBrowser()) {
    return false
  }

  if (debugForced) {
    return true
  }

  return window.localStorage.getItem(DEBUG_STORAGE_KEY) === "1"
}

export function setAnalyticsDebug(enabled: boolean) {
  if (!isBrowser()) {
    return
  }

  if (debugForced && !enabled) {
    return
  }

  if (enabled) {
    window.localStorage.setItem(DEBUG_STORAGE_KEY, "1")
    return
  }

  window.localStorage.removeItem(DEBUG_STORAGE_KEY)
}

export function forceAnalyticsDebug(enabled: boolean) {
  debugForced = enabled

  if (enabled) {
    setAnalyticsDebug(true)
  }
}

export function syncAnalyticsDebugFromUrl(urlPath: string) {
  if (!isBrowser()) {
    return
  }

  const url = new URL(urlPath, window.location.origin)
  const debugValue = url.searchParams.get("ga_debug")

  if (debugValue === "1") {
    setAnalyticsDebug(true)
  }

  if (debugValue === "0") {
    setAnalyticsDebug(false)
  }
}

export function initializeAnalytics(measurementId?: string | null) {
  if (!isBrowser() || !measurementId || initialized) {
    if (!measurementId) {
      debugLog("initialize_skipped", { reason: "missing_measurement_id" })
    }

    return
  }

  ReactGA.initialize(measurementId)
  initialized = true
  debugLog("initialize", { measurementId })
}

export function trackPageView(path: string, title?: string) {
  if (!initialized) {
    debugLog("pageview_skipped", { reason: "not_initialized", path, title })
    return
  }

  ReactGA.send({
    hitType: "pageview",
    page: path,
    title,
  })

  debugLog("pageview", { path, title })
}

export function trackEvent(eventName: string, params?: Record<string, string | number | boolean>) {
  if (!initialized) {
    debugLog("event_skipped", { reason: "not_initialized", eventName, params })
    return
  }

  ReactGA.event(eventName, params)
  debugLog("event", { eventName, params })
}
